export const UPDATE_CC_INPUT = 'UPDATE_CC_INPUT';

/** @namespace Pwa/Store/Creditcard/Action/handleCCInputChange */
export const handleCCInputChange = (data) => ({
    type: UPDATE_CC_INPUT,
    data
});
